import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    description: 'Modal title for the CubiScan integration setup modal',
    defaultMessage: 'Set Up Cubiscan',
    id: 'py7B6D',
  },
  highVolumeMerchants: {
    description: 'Desicribes how merchants can use the CubiScan integration',
    defaultMessage: 'ShipStation allows merchants to <a>import weights and dimensions from Cubiscan dimensioners.</a>',
    id: 'q72dKk',
  },
  addDimensioners: {
    description: 'add shipstation dimensioners',
    defaultMessage: '<b>Add dimensioners in ShipStation Connect:</b>',
    id: 'mCt6E0',
  },
  addDimensionersStep1: {
    description: 'add dimensioners step 1',
    defaultMessage: '1. Open the ShipStation Connect application.',
    id: '/meh+5',
  },
  addDimensionersStep2: {
    description: 'add dimensioners step 2',
    defaultMessage: '2. Select the <b>Devices</b> tab.',
    id: 'b2jMxQ',
  },
  addDimensionersStep3: {
    description: 'add dimensioners step 3',
    defaultMessage: '3. Click the <b>Add</b> button.',
    id: 'VIw2Mc',
  },
  needConnect: {
    description: 'need ShipStation Connect',
    defaultMessage: "<b>Don't have ShipStation Connect?</b>",
    id: '4D621T',
  },
  downloadConnect: {
    description: 'shipstation connect download link',
    defaultMessage: 'Go to <a>ShipStation Connect settings</a> to download the application.',
    id: 'yg7kr0',
  },
});
